var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var HotelFeature = function () {
            function HotelFeature() {
                var _this = this;

                _classCallCheck(this, HotelFeature);

                this.sections = [];
                this.opened = false;
                this.modalElement = null;
                this.contentIdList = {
                    about: 'hotelFeatureAboutContent', meal: 'hotelFeatureMealContent',
                    forChild: 'hotelFeatureForChildContent', beach: 'hotelFeatureBeachContent',
                    spa: 'hotelFeatureSpaContent', pool: 'hotelFeaturePoolContent'
                };
                $event.on('click', '.js-open-hotel-feature', function (event, element) {
                    return _this.open(element.dataset.eventtype);
                });
            }

            _createClass(HotelFeature, [{
                key: "prepare",
                value: function prepare() {
                    var _this2 = this;

                    if (this.sections.length) return;
                    this.panel = document.getElementById('hotelFeaturesPanel');
                    if (!this.panel) return;
                    var tabs = this.panel.querySelector('[data-feature-tabs]');
                    var panels = this.panel.querySelector('[data-feature-panels]');
                    document.querySelectorAll('.js-open-hotel-feature').forEach(function (trigger) {
                        var type = trigger.dataset.eventtype;
                        var content = document.getElementById(_this2.contentIdList[type]);
                        if (!content || _this2.sections.some(function (section) {
                            return section.type === type;
                        })) return;
                        var title = trigger.querySelector('.hotel-feature__title').textContent.trim();
                        var tab = document.createElement('button');
                        tab.type = 'button';
                        tab.className = 'hotel-features-panel__tab';
                        tab.id = content.id + 'Tab';
                        tab.setAttribute('role', 'tab');
                        tab.setAttribute('aria-controls', content.id);
                        var image = trigger.querySelector('.hotel-feature__img-wrap img');
                        if (image) {
                            var thumbnail = image.cloneNode(true);
                            thumbnail.alt = '';
                            tab.appendChild(thumbnail);
                        }
                        var label = document.createElement('span');
                        label.textContent = title;
                        tab.appendChild(label);
                        tabs.appendChild(tab);
                        content.setAttribute('role', 'tabpanel');
                        content.setAttribute('aria-labelledby', tab.id);
                        panels.appendChild(content);
                        var description = content.querySelector('.facility-hotel-description');
                        if (description) description.parentNode.prepend(description);
                        var detailBody = content.querySelector('.hotel-feature-detail-content');
                        var heading = content.querySelector('.hotel-feature-detail-title');
                        detailBody.querySelectorAll('.facility-title').forEach(function (subtitle) {
                            if (subtitle.textContent.trim() === heading.textContent.trim()) subtitle.remove();
                        });
                        detailBody.prepend(heading);
                        if (type === 'about') {
                            var facts = document.createElement('div');
                            facts.className = 'hotel-features-panel__facts';
                            Array.from(detailBody.children).forEach(function (child) {
                                if (child !== heading && child !== description) facts.appendChild(child);
                            });
                            content.appendChild(facts);
                        }
                        if (type === 'meal') {
                            var details = document.createElement('div');
                            details.className = 'hotel-features-panel__meal-details';
                            var items = detailBody.querySelector('.facility-items');
                            var additionalItems = document.createElement('div');
                            additionalItems.className = 'facility-items';
                            Array.from(items.children).slice(2).forEach(function (item) {
                                return additionalItems.appendChild(item);
                            });
                            details.appendChild(additionalItems);
                            Array.from(detailBody.children).forEach(function (child) {
                                if (child !== heading && child !== items) details.appendChild(child);
                            });
                            content.appendChild(details);
                        }
                        var section = { type: type, content: content, tab: tab, title: title, swiper: null };
                        _this2.sections.push(section);
                        tab.addEventListener('click', function () {
                            return _this2.select(type, true);
                        });
                        tab.addEventListener('keydown', function (event) {
                            var index = _this2.sections.indexOf(section);
                            var next = void 0;
                            if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % _this2.sections.length;
                            if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index + _this2.sections.length - 1) % _this2.sections.length;
                            if (event.key === 'Home') next = 0;
                            if (event.key === 'End') next = _this2.sections.length - 1;
                            if (next === undefined) return;
                            event.preventDefault();
                            _this2.select(_this2.sections[next].type, true);
                            _this2.sections[next].tab.focus();
                        });
                    });
                }
            }, {
                key: "open",
                value: function open(type) {
                    var _this3 = this;

                    this.prepare();
                    if (!this.panel || !this.sections.some(function (section) {
                        return section.type === type;
                    }) || this.opened) return;
                    this.opened = true;
                    window.modal.open({
                        header: null, footer: null, type: 'full',
                        parentCssClass: 'hotel-reviews-panel-modal hotel-features-modal',
                        content: { htmlDetachSelectorId: 'hotelFeaturesPanel' },
                        onAfterShow: function onAfterShow(modal) {
                            _this3.modalElement = modal;
                            _this3.select(type);
                        },
                        onBeforeRemove: function onBeforeRemove() {
                            _this3.opened = false;
                            _this3.modalElement = null;
                        }
                    });
                }
            }, {
                key: "select",
                value: function select(type) {
                    var _this4 = this;

                    var userInitiated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                    if (userInitiated && this.activeType !== type) {
                        if (window.brxTracking) window.brxTracking.sendAnalyticsEvent('hotel_feature_change', Object.assign({}, window.app && window.app.pageParams, { feature_type: type }));
                    }
                    this.activeType = type;
                    this.sections.forEach(function (section) {
                        var active = section.type === type;
                        section.content.hidden = !active;
                        section.tab.setAttribute('aria-selected', String(active));
                        section.tab.tabIndex = active ? 0 : -1;
                        if (active) _this4.initGallery(section);
                    });
                    if (this.modalElement) this.modalElement.querySelector('.modal2-content').scrollTop = 0;
                }
            }, {
                key: "initGallery",
                value: function initGallery(section) {
                    var element = section.content.querySelector('.hotel-feature-swiper');
                    if (!element) return;
                    if (section.swiper) {
                        section.swiper.update();
                        return;
                    }
                    var thumbnails = document.createElement('div');
                    thumbnails.className = 'hotel-features-panel__thumbnails';
                    var buttons = Array.from(element.querySelectorAll('.hotel-feature-img')).map(function (image, index) {
                        var button = document.createElement('button');
                        button.type = 'button';
                        button.setAttribute('aria-label', section.title + ' — ' + (index + 1));
                        var thumbnail = image.cloneNode(true);
                        thumbnail.src = image.src.replace('/img/h/big/', '/img/h/sm/');
                        thumbnail.alt = '';
                        thumbnail.loading = 'lazy';
                        button.appendChild(thumbnail);
                        button.addEventListener('click', function () {
                            return section.swiper.slideTo(index);
                        });
                        thumbnails.appendChild(button);
                        return button;
                    });
                    if (buttons.length > 1) element.parentNode.appendChild(thumbnails);
                    var syncThumbnails = function syncThumbnails(swiper) {
                        return buttons.forEach(function (button, index) {
                            button.setAttribute('aria-pressed', String(index === swiper.activeIndex));
                            if (index === swiper.activeIndex) thumbnails.scrollLeft = button.offsetLeft - thumbnails.offsetLeft;
                        });
                    };
                    section.swiper = new Swiper(element, {
                        slidesPerView: 1, spaceBetween: 14, loop: false,
                        navigation: {
                            nextEl: element.querySelector('.hotel-feature-control-next'),
                            prevEl: element.querySelector('.hotel-feature-control-prev')
                        },
                        pagination: { el: element.querySelector('.hotel-feature-pagination'), type: 'fraction' },
                        on: { slideChange: syncThumbnails }
                    });
                    syncThumbnails(section.swiper);
                }
            }]);

            return HotelFeature;
        }();

        window.HotelFeature = new HotelFeature();
    }, {}] }, {}, [1]);